<div class="container-fluid">
    <h1 class="m-3 display-6 vm-container-header">
        <i class="bi bi-globe me-2"></i>Web Data Connections
    </h1>

    <div class="m-3 p-2 bg-body-light rounded-3 shadow">
        <div class="m-2">
            <form autocomplete="off">
                <div class="mb-3 row align-items-center">
                    <div class="col-sm-auto">
                        <select (change)="this.onCustomerChange($event)" class="form-select">
                            <option selected value="">Select a Customer</option>
                            @for (entity of this.customers; track entity.id;) {
                                <option value="{{ entity.id }}">{{ entity.name }}</option>
                            }
                        </select>
                    </div>

                    <app-table-search [(value)]="this.webDataConnectionService.searchTerm" />
                </div>
            </form>

            @if (!!this.selectedCustomerId && ((this.total$ | async) ?? 0) > 0) {
                <table class="table table-striped table-hover">
                    <caption>
                        <div class="container-fluid w-100">
                            <div class="row justify-content-center align-self-center">
                                <div class="col align-self-center">
                                    {{ this.total$ | async }} Total
                                </div>
                                @if (!!this.selectedCustomerId) {
                                    <div class="col-sm-auto" role="group">
                                        <button (click)="onAddWebDataConnection()"
                                                class="btn btn-sm btn-outline-primary"
                                                title="Add Web Data Connection">
                                            <i class="bi bi-plus-circle me-1"></i> Add
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </caption>

                    <thead>
                    <tr>
                        <th (sort)="this.onSort($event)" scope="col" sortable="name">Name</th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="type">Type</th>
                        <th (sort)="this.onSort($event)" class="text-center" scope="col" sortable="isActive">
                            Active
                        </th>
                        <th (sort)="this.onSort($event)" class="text-center" scope="col" sortable="refreshHour">
                            Refresh Hour
                        </th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="updatedAt">Updated At</th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="lastRunAt">Last Run</th>
                        <th class="text-center" scope="col">Actions</th>
                    </tr>
                    </thead>

                    <tbody class="table-group-divider">
                        @for (element of this.webDataConnectionService.data$ | async; track element.webDataConnectionId; ) {
                            <tr class="align-middle">
                                <td>{{ element.name }}</td>
                                <td>{{ this.getWebDataConnectionTypeLabel(element.type) }}</td>
                                <td class="text-center">
                                    @if (element.isActive) {
                                        <span class="badge bg-success"><i class="bi bi-check-lg"></i></span>
                                    }
                                    @else {
                                        <span class="badge bg-danger"><i class="bi bi-x-lg"></i></span>
                                    }
                                </td>
                                <td class="text-center">{{ element.refreshHour }}</td>
                                <td>{{ this.longFormatDate(element.updatedAt) }}</td>
                                <td>{{ this.longFormatDate(element.lastRunAt) }}</td>
                                <td class="text-center">
                                    <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
                                        <button type="button" class="btn btn-sm btn-outline-primary"
                                                id="downloadBtn-{{element.webDataConnectionId}}"
                                                (focus)="myDrop.open()" ngbDropdownAnchor>
                                            <i class="bi bi-gear"></i>
                                        </button>
                                        <div ngbDropdownMenu>
                                            <button type="button" ngbDropdownItem
                                                    (click)="this.onViewWebDataConnection(element)">
                                                <i class="bi bi-search me-2"></i>View Details
                                            </button>
                                            <button type="button" ngbDropdownItem
                                                    (click)="this.onEditWebDataConnection(element)">
                                                <i class="bi bi-pencil me-2"></i>Edit
                                            </button>
                                            <button type="button" ngbDropdownItem
                                                    (click)="this.onViewWebDataConnectionRuns(element)">
                                                <i class="bi bi-list-check me-2"></i>View Runs
                                            </button>
                                            <button type="button" ngbDropdownItem
                                                    (click)="this.onRefreshWebDataConnection(element)">
                                                <i class="bi bi-arrow-clockwise me-2"></i>Refresh Now
                                            </button>
                                            <button type="button" ngbDropdownItem
                                                    (click)="this.onDeleteWebDataConnection(element)">
                                                <i class="bi bi-trash3 me-2 text-danger"></i><span class="text-danger">Delete</span>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            }

            @if (!!this.selectedCustomerId && ((this.total$ | async) ?? 0) > 0) {
                <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.webDataConnectionService.page" [(pageSize)]="this.webDataConnectionService.pageSize" />
            }

            @if (!this.selectedCustomerId) {
                <div class="card text-center bg-info-subtle border border-info rounded p-3 m-5">
                    <div class="card-body">
                        <i class="bi bi-info-circle-fill me-2"></i>Select a customer to see its web data connections.
                    </div>
                </div>
            }

            @if (!!this.selectedCustomerId && ((this.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                    <div class="card-body">
                        <div>
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>No web data connections found.
                        </div>
                        <div (click)="onAddWebDataConnection()" class="btn btn-primary mt-5"
                             title="Add Web Data Connection">
                            <i class="bi bi-plus-circle me-1"></i>
                            Click here to add a web data connection.
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>

    <ng-template #webDataConnectionModal>
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="webDataConnectionModalLabel">
                {{ isEditMode ? 'Edit' : 'Add' }} Web Data Connection
            </h1>
            <button (click)="onWebDataConnectionDismiss()" aria-label="Close" class="btn-close" type="button"></button>
        </div>

        <form (ngSubmit)="onWebDataConnectionSubmit()" [formGroup]="webDataConnectionForm" autocomplete="off">
            <div class="modal-body container-fluid">
                <div class="row g-0">
                    <div class="form-floating mt-3 vm-pe-1">
                        <input class="form-control" formControlName="name" id="nameControl" placeholder="Name"
                               type="text">
                        <label class="form-label" for="nameControl">Name</label>
                    </div>

                    <div class="form-floating mt-3 vm-pe-1">
                        <input class="form-control" formControlName="description"
                               id="descriptionControl" placeholder="Description" type="text">
                        <label class="form-label" for="descriptionControl">Description</label>
                    </div>

                    <div class="form-floating mt-3 vm-pe-1">
                        <select class="form-select" formControlName="type" id="typeControl">
                            @for (webDataConnectionType of this.typeOptions; track webDataConnectionType; ) {
                                <option [value]="webDataConnectionType">
                                    {{ this.getWebDataConnectionTypeLabel(webDataConnectionType) }}
                                </option>
                            }
                        </select>
                        <label class="form-label" for="typeControl">Type</label>
                    </div>

                    @if (this.controls.type.value == this.WebDataConnectionType.Sql) {
                        <div class="form-floating mt-3 vm-pe-1">
                            <textarea class="form-control font-monospace" formControlName="sqlText" id="sqlTextControl"
                                      placeholder="SQL Text" style="height: 200px;"></textarea>
                            <label class="form-label" for="sqlTextControl">SQL Text</label>
                        </div>
                    }

                    @if (this.controls.type.value == this.WebDataConnectionType.ThoughtSpotAnswerReport) {
                        <div class="form-floating mt-3 vm-pe-1">
                            <select class="form-select" formControlName="thoughtSpotUserName"
                                    id="thoughtSpotUserNameControl" (change)="this.onUserChange($event)">
                                <option value="">Select a user</option>
                                @for (user of this.users; track user.id; ) {
                                    <option [value]="user.email">{{ user.email }}</option>
                                }
                            </select>
                            <label class="form-label" for="thoughtSpotUserNameControl">ThoughtSpot User</label>
                        </div>

                        <div class="form-floating mt-3 vm-pe-1">
                            <select class="form-select" formControlName="thoughtSpotAnswerId"
                                    id="thoughtSpotAnswerControl">
                                <option value="">Select a ThoughtSpot Answer</option>
                                @for (answer of this.answers; track answer.id; ) {
                                    <option [value]="answer.id">{{ answer.name }}</option>
                                }
                            </select>
                            <label class="form-label" for="thoughtSpotUserNameControl">ThoughtSpot Answer</label>
                        </div>
                    }

                    <div class="form-floating mt-3 vm-pe-1">
                        <input class="form-control" formControlName="refreshHour" id="refreshHourControl"
                               max="23" min="0" placeholder="Refresh Hour" type="number">
                        <label class="form-label" for="refreshHourControl">Refresh Hour (0-23)</label>
                    </div>

                    <div class="form-floating col-md-4 mt-3 vm-pe-1">
                        <div class="form-check form-check-inline form-switch">
                            <input class="form-check-input" formControlName="isActive" id="isActiveControl"
                                   role="switch"
                                   type="checkbox">
                            <label class="form-check-label" for="isActiveControl">Is Active</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button [disabled]="savingData" class="btn btn-primary" type="submit">
                    @if (savingData) {
                        <span class="spinner-border spinner-border-sm me-1"></span>
                    }
                    Save
                </button>
                <button (click)="onWebDataConnectionDismiss()" class="btn btn-secondary" type="button">Close</button>
            </div>
        </form>
    </ng-template>

    <ng-template #webDataConnectionRunsModal>
        <div class="modal-header">
            <h1 class="modal-title fs-5">Runs - {{ selectedRunsConnectionName }}</h1>
            <button (click)="onViewWebDataConnectionRunsDismiss()" class="btn-close" type="button"></button>
        </div>

        <div class="modal-body">
            <table class="table table-striped table-hover mb-0">
                <caption>
                    <div class="container-fluid w-100">
                        <div class="row justify-content-center align-self-center">
                            <div class="col align-self-center">
                                {{ this.runsTotal$ | async }} Total
                            </div>
                        </div>
                    </div>
                </caption>
                <thead>
                <tr>
                    <th (sort)="this.onSortRuns($event)" scope="col" sortable="createdAt" style="min-width: 10em;">
                        Created At
                    </th>
                    <th (sort)="this.onSortRuns($event)" scope="col" sortable="fileName" >File Name</th>
                    <th scope="col" class="text-center">Download</th>
                </tr>
                </thead>
                <tbody>
                    @for (run of (this.webDataConnectionRunsService.data$ | async); track run.key + run.lastModified; ) {
                        <tr class="align-middle">
                            <td>{{ this.longFormatDate(run.lastModified) }}</td>
                            <td class="text-ellipsis" title="{{run.fileName}}">
                                {{ run.fileName }}
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-outline-primary me-2"
                                        (click)="this.onDownloadFile(this.selectedCustomerId!, this.selectedWebDataConnectionId!, run.fileName, run.versionId)">
                                    <i class="bi bi-download"></i>
                                </button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>

            <div class="d-flex justify-content-between p-2">
                <ngb-pagination [(page)]="this.webDataConnectionRunsService.page"
                                [collectionSize]="(this.runsTotal$ | async)!"
                                [pageSize]="this.webDataConnectionRunsService.pageSize" [ellipses]="true"
                                [maxSize]="10"></ngb-pagination>

                <select [(ngModel)]="this.webDataConnectionRunsService.pageSize" class="form-select" name="pageSize" style="width: auto">
                    @for (element of this.globalService.pagination; track element; ) {
                        <option [ngValue]="element">
                            {{ element }} items per page
                        </option>
                    }
                </select>
            </div>
        </div>
        <div class="modal-footer">
            <button (click)="onViewWebDataConnectionRunsDismiss()" class="btn btn-secondary" type="button">Close</button>
        </div>
    </ng-template>

    <ng-template #viewWebDataConnectionModal>
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="viewWebDataConnectionModalLabel">
                Web Data Connection Details
            </h1>
            <button (click)="onViewWebDataConnectionDismiss()" class="btn-close" type="button"></button>
        </div>

        <div class="card bg-info-subtle border border-info rounded m-3 mb-0">
            <div class="card-header">
                <h6 class="card-title m-0"><i class="bi bi-info-circle me-2"></i>Excel Power Query Setup</h6>
            </div>
            <div class="card-body">
                <p>Use the "URL" and "API Key" to setup a web connection in Excel:</p>
                <ol class="mb-0">
                    <li>Copy the URL</li>
                    <Li>In Excel, open the Data menu and select "From Web"</Li>
                    <li>Click "Advanced" and paste the URL</li>
                    <li>Copy the API Key</li>
                    <li>
                        Under "HTTP request header parameters":
                        <ol>
                            <li>Enter <code>ApiKey</code> into the first field.</li>
                            <li>Paste the Api Key into the second field.</li>
                        </ol>
                    </li>
                    <li>Click "OK"</li>
                </ol>
            </div>
        </div>

        <form [formGroup]="webDataConnectionForm">
            <div class="modal-body container-fluid">
                <div class="row g-0">
                    <div class="form-floating mt-3 vm-pe-1">
                        <input [readonly]="true" class="form-control" formControlName="name"
                               id="viewNameControl" placeholder="Name" type="text">
                        <label class="form-label" for="viewNameControl">Name</label>
                    </div>

                    <div class="form-floating mt-3 vm-pe-1">
                        <input [readonly]="true" class="form-control" formControlName="description"
                               id="viewDescriptionControl" placeholder="Description" type="text">
                        <label class="form-label" for="viewDescriptionControl">Description</label>
                    </div>

                    <div class="mt-3 vm-pe-1">
                        <div class="input-group">
                            <div class="form-floating">
                                <input [disabled]="true" [readonly]="true"
                                       [value]="currentConnectionUrl" class="form-control font-monospace"
                                       id="viewUrlControl" placeholder="URL"
                                       type="text">
                                <label for="viewUrlControl">URL</label>
                            </div>
                            <button (click)="copyUrlToClipboard()" class="btn btn-outline-primary"
                                    title="Copy" type="button">
                                <i class="bi bi-copy"></i>
                            </button>
                        </div>
                    </div>

                    <div class="mt-3 vm-pe-1">
                        <div class="input-group">
                            <div class="form-floating">
                                <input [disabled]="true" [readonly]="true"
                                       [value]="currentCustomerApiKey" class="form-control font-monospace"
                                       id="viewApiKeyControl" placeholder="API Key"
                                       type="text">
                                <label for="viewApiKeyControl">API Key</label>
                            </div>
                            <button (click)="copyApiKeyToClipboard()" class="btn btn-outline-primary"
                                    title="Copy" type="button">
                                <i class="bi bi-copy"></i>
                            </button>
                        </div>
                    </div>

                    <div class="form-floating mt-3 vm-pe-1">
                        <input [disabled]="true" [readonly]="true" class="form-control"
                               [value]="this.getWebDataConnectionTypeLabel(this.controls.type.value)"
                               id="viewTypeControl" placeholder="Type" type="text">
                        <label class="form-label" for="viewTypeControl">Type</label>
                    </div>

                    @if (this.controls.type.value == this.WebDataConnectionType.Sql) {
                        <div class="form-floating mt-3 vm-pe-1">
                            <textarea [readonly]="true" class="form-control font-monospace" formControlName="sqlText"
                                      id="viewSqlTextControl" placeholder="SQL Text" style="height: 200px;"></textarea>
                            <label class="form-label" for="viewSqlTextControl">SQL Text</label>
                        </div>
                    }

                    @if (this.controls.type.value == this.WebDataConnectionType.ThoughtSpotAnswerReport) {
                        <div class="form-floating mt-3 vm-pe-1">
                            <input [disabled]="true" [readonly]="true" class="form-control"
                                   formControlName="thoughtSpotAnswerName" id="viewThoughtSpotAnswerNameControl"
                                   placeholder="ThoughtSpot Answer" type="text">
                            <label class="form-label" for="viewThoughtSpotAnswerNameControl">ThoughtSpot Answer</label>
                        </div>
                        <div class="form-floating mt-3 vm-pe-1">
                            <input [readonly]="true" class="form-control" formControlName="thoughtSpotUserName"
                                   id="viewThoughtSpotUserNameControl" placeholder="ThoughtSpot User Name" type="text">
                            <label class="form-label" for="viewThoughtSpotUserNameControl">ThoughtSpot User</label>
                        </div>
                    }

                    <div class="form-floating mt-3 vm-pe-1">
                        <input [disabled]="true" [readonly]="true" class="form-control"
                               formControlName="refreshHour" id="viewRefreshHourControl" placeholder="Refresh Hour"
                               type="number">
                        <label class="form-label" for="viewRefreshHourControl">Refresh Hour (0-23)</label>
                    </div>

                    <div class="col-md-4 mt-3 vm-pe-1">
                        <div class="form-check form-check-inline form-switch">
                            <input [disabled]="true" class="form-check-input" formControlName="isActive"
                                   id="isActiveControl"
                                   role="switch" type="checkbox">
                            <label class="form-check-label" for="isActiveControl">Is Active</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button (click)="onViewWebDataConnectionDismiss()" class="btn btn-secondary" type="button">Close
                </button>
            </div>
        </form>
    </ng-template>

    <app-modal-confirm #confirmationModal></app-modal-confirm>
</div>
